import { apiProxyRequest } from "Api/apiProxyRequest";
import { DeploymentSettings } from "Reducers/environment/deployment";

import { getDeploymentSettingsUrl } from "./utils";

export const getDeploymentSettingsRequest = ({ projectId, environmentId }) => {
  return apiProxyRequest<DeploymentSettings>(
    getDeploymentSettingsUrl({ projectId, environmentId }),
    "GET"
  );
};
